export const togglePasswordVisibility = (setShowPassword, showPassword) => {
  setShowPassword(!showPassword);
};

export const handlePasswordChange = (setPassword, e) => {
  setPassword(e.target.value);
};
